// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-beta.62e752e8b',
  revision: '62e752e8b',
  branch: 'develop',
  date: 'Mon, 19 Oct 2026 18:33:03 GMT'
};